
export enum DefaultUserType {
  RoundRobin = 'roundRobin'
}

/**
 * Config for integrating the calendar in the order view.
 */
export class ProjectCalendarOrderConfig {
  /**
   * Object of operators to get the default event title.
   */
  readonly defaultEventTitle: any = { _text: '' };
  /**
   * Object of operators to get the default event description.
   */
  readonly defaultEventDescription: any = { _text: '' };
  readonly isEventRequired: boolean = true;
  
  /**
   * Controls which user's calendar is default in the order view.
   */
  readonly defaultUserType?: DefaultUserType;

  constructor(deriveFrom?: Partial<ProjectCalendarOrderConfig>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }
}